import React, { useEffect, useRef, useState } from "react";
import { Map, ZoomControl, TileLayer } from "react-leaflet";
import HeatmapLayer from "react-leaflet-heatmap-layer";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import { FeatureGroup } from "react-leaflet";
import { withSnackbar } from "notistack";

import UsersVehiclesPlotting from "components/AiMap/MapChilds/UsersVehiclesPlotting";
import RoutesAndTerritories from "components/AiMap/MapChilds/RoutesAndTerritories";
import MapTopFilters from "components/AiMap/Menus/TopMenu";
import MapRightSideFilters from "components/AiMap/Menus/RightMenu";
import RightSideDrawer from "components/AiMap/Options/RightSideDrawer";
import MapDrillDown from "components/AiMap/MapChilds/MapDrillDown";
import PieChartOnMap from "components/AiMap/MapChilds/PieChartOnMap";
import CustomerPlotting from "components/AiMap/MapChilds/CustomerPlotting";
import MapLeftSideFilters from "components/AiMap/Menus/LeftMenu";
import Loader from "components/Custom/Loader";
import MapShare from "components/AiMap/Options/MapShare";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "./styles/index.css";
import "./styles/fleetmap.css";

import { COMMON_JS } from "common/scripts";
import { mapLocalStorage } from "common/config";
import { TRIP_STATUS } from "common/config";
import { CONFIG, DEFAULTS, LOCAL_STORAGE } from "common/config";
import { INFO } from "common/lables";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { MASTER_APIs } from "apihandlers/master";
import { GEO_APIs } from "apihandlers/geography";
import { USER_APIs } from "apihandlers/user";

const otherImg = require("./images/marker-other.png");
const gopalImg = require("./images/marker-gopal.png");
const markerRed = require("./images/location_32x32.png");

const AiMap = (props: any) => {
  const { setPageMenu } = props;

  const mapRef: any = useRef(null);
  const dealersRef: any = useRef(null);
  const deliveriesRef: any = useRef(null);
  const mapDrawControl: any = useRef(null);
  const mapDrawControlGroup: any = useRef(null);
  const territoryRef: any = useRef(null);

  const [selectedCustomers, setSelectedCustomers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [showMarker, setShowMarker] = useState<boolean>(false);
  const [showTerritory, setShowTerritory] = useState<boolean>(true);
  const [showRoute, setShowRoute] = useState<boolean>(true);
  const [customers, setCustomers] = useState<any>(null);
  const [dealers, setDealers] = useState<any>([]);
  const [sales, setSales] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElTrips, setAnchorElTrips] = useState(null);
  const [tripState, setTripState] = useState<any>(TRIP_STATUS);
  const [mapTypes, setMapTypes] = useState<boolean>(false);
  const [showTripDelivery, setShowTripDelivery] = useState<any>(false);
  const [details, setDetails] = useState<boolean>(false);
  const [showCharts, setShowCharts] = useState<boolean>(false);
  const [vehicle, setVehicle] = useState<any>(null);
  const [plotDetail, setPlotDetail] = useState<any>(null); //when clicking any plotted data like polygon,polyline the data is showed in the right side
  const [plottings, setPlottings] = useState<boolean>(false); //when clicking any plotted data like polygon,polyline the data is showed in the right side
  const [showVehicles, setShowVehicles] = useState<any>(false);
  const [showUser, setShowUser] = useState<any>(false);
  const [tripDelivery, setTripDelivery] = useState<any>(null);
  const [showRecords, setShowRecords] = useState<boolean>(false); //when clicking the report button on the left side filter the slider will appear
  const [showDealers, setShowDealer] = useState<boolean>(true);
  const [showLabels, setShowLabels] = useState<boolean>(false);
  const [tripStatus, setTripStatus] = useState<boolean>(false);
  const [polyEdits, setPolyEdits] = useState<boolean>(false);
  const [transferring, setTransferring] = useState<boolean>(false);
  const [mapPosition, setMapPosition] = useState<any>(mapLocalStorage);
  const [showDrilldown, setShowDrilldown] = useState<boolean>(false);
  const [showInnerBoundry, setShowInnerBoundry] = useState<boolean>(true);
  const [showOuterBoundry, setShowOuterBoundry] = useState<boolean>(true);
  const [showCustomerCluster, setShowCustomerCluster] = useState<boolean>(true);
  const [usersData, setUsersData] = useState<any>(null);
  const [filteredDealersList, setFilteredDealersList] = useState<any>(null); // Used for conditional rendering
  const [trackedUsers, setTrackedUsers] = useState<any>(null);
  const [scavenging, setScavenging] = useState<any>(false); // for setting the scavenging page
  const [streetView, setStreetView] = useState<any>(false); // for setting the scavenging page

  let mType = localStorage.getItem(LOCAL_STORAGE.MAP_TYPE);
  const [selectedMapType, setSelectedMapType] = useState<any>(
    mType ? Number(mType) : 0
  );

  useEffect(() => {
    if (loading) {
      getDealers().then((list) => {
        setDealers(list);
        setLoading(false);
      });
    }
  }, [loading]);

  const getFilteredDealers = async (qryObj: any = {}) => {
    try {
      console.log("qryObj", qryObj);
      const dList = await getDealers(qryObj);
      setFilteredDealersList([...dList]);
    } catch (error) {
      console.log("getFilteredDealers: error:", error);
    }
  };

  const getDealers = async (qryObj: any = {}) => {
    let dealersList = [];
    try {
      const args = {
        pageNo: 1,
        pageLength: 500,
        minResponse: true,
        stateIds: qryObj.stateIds || null,
        districtIds: qryObj.districtIds || null,
        regionIds: qryObj.regionIds || null,
        cityIds: qryObj.cityIds || null,
        areaIds: qryObj.areaIds || null,
      };
      const res: any = await MASTER_APIs.getOrgProfiles(args);
      if (res.status === 200) {
        dealersList = res.response.records.map((rec: any) => {
          return {
            id: rec.id,
            label: rec.organizationName,
            ...rec,
          };
        });
      }
      getVehicleDetail();
    } catch (error) {
      console.log("getDealers: ", error);
    }
    return dealersList;
  };

  const getCustomers = async (dealerId, areaId, shopRoutes) => {
    try {
      const orgId = dealerId;
      const args = {
        getRouteShops: shopRoutes,
        orgId,
        areaId,
        // areaId: "16296,18450",
      };
      setRefresh(true);
      setCustomers(null);
      const res: any = await CUSTOMER_APIs.getAllCustomersOnMap(args);
      if (res.status === 200) {
        const tempList = res.response.records.map((r, i) => {
          r["slNo"] = i + 1;
          return r;
        });
        setCustomers([...tempList]);
        setRefresh(false);
      }
    } catch (error) {
      console.log("getCustomers: ", error);
    }
  };

  const getMonthSales = async (e, newValue: any) => {
    try {
      const args = {
        month: newValue / 8,
      };
      const res = await GEO_APIs.getSalesAnalysis(args);
      const { response, status } = res;
      if (status === 200) {
        setSales(res.response);
      }
      setShowRecords(true);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  const getUsersOnMap = async (orgId) => {
    const args = { orgId, marketingexec: "marketingexec" };
    const res: any = await USER_APIs.getUsers(args);
    if (res.status == 200) {
      const userInfo = res.response.records;
      let list = userInfo.map((r: any) => {
        return {
          id: r.id,
          label: r.uname,
        };
      });
      setUsersData(list);
    }
  };

  const getVehicleDetail = async () => {
    const args = { orgId: 1 };
    const res: any = await MASTER_APIs.getVehiclesOnMapWoToken(args);
    if (res.status == 200) {
      const vehicleInfo = res.response.records;
      console.log("vehicleInfo", vehicleInfo);
      setVehicle(vehicleInfo);
      // setShowVehicles(!showVehicles);
      // setShowMarker(true)
    }
  };

  const createClusterCustomIcon = (cluster) => {
    const count = cluster.getChildCount();
    let size = "LargeXL";
    if (count < 10) {
      size = "Small";
    } else if (count > 9 && count < 100) {
      size = "Medium";
    } else if (count > 99 && count < 1000) {
      size = "Large";
    }
    const options = {
      cluster: `markerCluster${size}`,
    };
    return L.divIcon({
      html: `<div>
          <span class="markerClusterLabel">${count}</span>
        </div>`,
      className: `${options.cluster}`,
    });
  };

  const updateLocation = (pos: any, zoom = DEFAULTS.MAX_ZOOM - 2) => {
    localStorage.setItem(LOCAL_STORAGE.MAP, JSON.stringify({ ...pos, zoom }));
    setMapPosition({ ...pos, zoom });
  };

  const getTileUrl = (mapType = 0) => {
    localStorage.setItem(LOCAL_STORAGE.MAP_TYPE, mapType.toString());
    let url = CONFIG.OSM_TILE_URL;
    switch (mapType) {
      case 0:
        url = CONFIG.OSM_TILE_URL;
        break;
      case 1:
        url = CONFIG.GOOGLE_STREETS_MAP_URL;
        break;
      case 2:
        url = CONFIG.GOOGLE_SATELLITE_MAP_URL;
        break;
      case 3:
        url = CONFIG.GOOGLE_HYBRID_MAP_URL;
        break;
      default:
        url = CONFIG.OSM_TILE_URL;
        break;
    }
    return url;
  };

  const getMapMarker = (orgId) => {
    let iconUrl = gopalImg;
    if (orgId) {
      iconUrl = otherImg;
    } else {
      iconUrl = markerRed;
    }
    let customMarker = null;
    let width = 26;
    let angle = 0;

    const html =
      "<div class='movingMarker' id='movingmarker-" +
      orgId +
      "' style='transform: rotate(" +
      angle.toString() +
      "deg);'><img src='" +
      iconUrl +
      "' alt='' width='" +
      width +
      "px'/></div>";

    customMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(16, 16),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });

    return customMarker;
  };

  const mPos = {
    lat: Number(mapPosition.lat),
    lng: Number(mapPosition.lng),
  };

  let zoom = Number(mapPosition.zoom);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTripStatus(false);
    setMapTypes(!mapTypes);
  };

  const handleClose = () => {
    setMapTypes(false);
  };

  const onTripDeliveries = (detail) => {
    polygonFitBounds(deliveriesRef.tripGroupRef, detail.vertices);
  };

  const polygonFitBounds = (polygonRef, boundData) => {
    let bounds = boundData.map((bound) => ({
      lat: bound[0],
      lng: bound[1],
    }));
    if (!bounds) {
      let layers = polygonRef.current.leafletElement._layers;
      for (let i in layers) {
        bounds = layers[i]._bounds;
      }
    }
    if (bounds) {
      mapRef.current.leafletElement.fitBounds(bounds);
    }
  };

  const onFilterCustomers = (latLngs = []) => {
    latLngs = latLngs.map((l: any) => {
      return {
        lat: l.lat,
        lng: l.lng,
      };
    });
    let fCustomers = [];
    for (let i = 0; i < customers.length; i++) {
      let lat = customers[i].lat;
      let lng = customers[i].lng;
      if (lat != null && lat != 0) {
        if (COMMON_JS.isPointInPolygon(latLngs, lat, lng)) {
          fCustomers.push(customers[i]);
        }
      }
    }
    setSelectedCustomers(fCustomers);
  };

  const reloadTerritories = () => {
    territoryRef.getTerritories();
  };

  const onSelectTripStatus = (checked, f) => {
    let tripList = tripState;
    if (tripState.indexOf(f) === -1) {
      tripList.push(f);
    } else {
      tripList = tripState.filter((s) => s !== f);
    }
    if (f === "All") {
      if (checked) {
        tripList = TRIP_STATUS;
      } else {
        tripList = [];
      }
    } else {
      if (tripList.length !== TRIP_STATUS.length) {
        tripList = tripList.filter((shop) => shop !== "All");
      }
    }
    const allChecked = TRIP_STATUS.slice(1).every((shop) =>
      tripList.includes(shop)
    );
    if (allChecked && !tripList.includes("All")) {
      tripList.push("All");
    }
    setTripState([...tripList]);
  };

  const handlePopoverClose = () => {
    setTripStatus(false);
  };

  const getTripStatus = (e) => {
    setAnchorElTrips(e.currentTarget);
    setMapTypes(false);
    setTripStatus(!tripStatus);
  };

  const printOptions = {
    position: "topleft",
    sizeModes: ["Current", "A4Portrait", "A4Landscape"],
    hideControlContainer: false,
    title: INFO.EXPORT_AS_PDF,
  };

  const downloadOptions = {
    position: "topleft",
    sizeModes: ["Current", "A4Portrait", "A4Landscape"],
    hideControlContainer: false,
    title: INFO.EXPORT_AS_PNG,
    exportOnly: true,
  };

  console.log("customersOnLoad", customers);

  return (
    <>
      {scavenging || streetView ? (
        <MapLeftSideFilters
          scavenging={scavenging}
          streetView={streetView}
          setScavenging={(val: any) => {
            setScavenging(val);
          }}
          setStreetView={(val: any) => {
            setStreetView(val);
          }}
        />
      ) : (
        <div style={{ width: "99%", position: "relative" }}>
          {(loading || refresh) && (
            <div className="mapLoading">
              <Loader />
            </div>
          )}
          <div
            id="aiMapContainer"
            className={"mapContainer"}
            style={{
              width: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Map
              center={mPos}
              zoom={zoom}
              maxZoom={DEFAULTS.MAX_ZOOM}
              minZoom={DEFAULTS.MIN_ZOOM}
              viewport={null}
              // onZoomend={getZoomLevel}
              className="fleetMap"
              zoomControl={true}
              ref={mapRef}
              style={{
                width: "100%",
                height: window.innerHeight * 0.97,
              }}
            >
              <TileLayer url={getTileUrl(selectedMapType)} />
              <ZoomControl position="topright" />
              <MapTopFilters
                loading={loading}
                dealers={dealers}
                customers={customers}
                filteredDealersList={filteredDealersList}
                setPlottings={(val: any) => {
                  setPlottings(val);
                }}
                setDealers={(val: any) => {
                  setDealers(val);
                }}
                setCustomers={(val: any) => {
                  setCustomers(val);
                }}
                setFilteredDealersList={(val: any) => {
                  setFilteredDealersList(val);
                }}
                getDealers={getDealers}
                getFilteredDealers={getFilteredDealers}
                getCustomers={getCustomers}
              />

              {showRecords && (
                <HeatmapLayer
                  points={sales}
                  longitudeExtractor={(point) => point.longitude}
                  latitudeExtractor={(point) => point.latitude}
                  intensityExtractor={(point) => point.intensity}
                />
              )}

              <CustomerPlotting
                createClusterCustomIcon={createClusterCustomIcon}
                customers={customers}
                showCustomerCluster={showCustomerCluster}
                setShowCustomerCluster={(val: any) => {
                  setShowCustomerCluster(val);
                }}
                getMapMarker={getMapMarker}
              />

              <FeatureGroup ref={mapDrawControlGroup}>
                <EditControl
                  position="topright"
                  onEdited={COMMON_JS.onEditPath}
                  onCreated={(e) => {
                    const latLngs = COMMON_JS.onCreate(e);
                    onFilterCustomers(latLngs[0]);
                  }}
                  onDeleted={COMMON_JS.onDeleted}
                  draw={{
                    polygon: true,
                    circle: true,
                  }}
                  ref={mapDrawControl}
                />
              </FeatureGroup>

              {/* territory and route plotting component */}
              <RoutesAndTerritories
                childRef={territoryRef}
                showMarker={showMarker}
                sales={sales}
                showLabels={showLabels}
                showDealers={showDealers}
                showTerritory={showTerritory}
                showRoute={showRoute}
                showOuterBoundry={showOuterBoundry}
                showInnerBoundry={showInnerBoundry}
                plottings={plottings}
                showCustomerCluster={showCustomerCluster}
                getCustomers={getCustomers}
                setShowUser={(val: any) => {
                  setShowUser(val);
                }}
                setShowCustomerCluster={(val: any) => {
                  setShowCustomerCluster(val);
                }}
                setShowTripDelivery={(val: any) => {
                  setShowTripDelivery(val);
                }}
                setPolyEdits={(val: any) => {
                  setPolyEdits(val);
                }}
                setPlottings={(val: any) => {
                  setPlottings(val);
                }}
                setPlotDetail={(val: any) => {
                  setPlotDetail(val);
                }}
              />

              {/* users, trip deliveries and vehicles component*/}
              <UsersVehiclesPlotting
                childRef={deliveriesRef}
                vehicle={vehicle}
                showUser={showUser}
                trackedUsers={trackedUsers}
                showVehicles={showVehicles}
                details={details}
                tripDelivery={tripDelivery}
                showMarker={showMarker}
                showLabels={showLabels}
              />

              <MapDrillDown
                updateLocation={updateLocation}
                getMapMarker={getMapMarker}
                showDrilldown={showDrilldown}
              />

              <PieChartOnMap
                showCharts={showCharts}
                setShowCharts={(val: any) => {
                  setShowCharts(val);
                }}
              />
            </Map>

            {/* Map Types filter */}
            <MapRightSideFilters
              showRecords={showRecords}
              showMarker={showMarker}
              showUser={showUser}
              plottings={plottings}
              showVehicles={showVehicles}
              getVehicleDetail={getVehicleDetail}
              showTripDelivery={showTripDelivery}
              getMonthSales={getMonthSales}
              polyEdits={polyEdits}
              showTerritory={showTerritory}
              showDealers={showDealers}
              showLabels={showLabels}
              showRoute={showRoute}
              showOuterBoundry={showOuterBoundry}
              showInnerBoundry={showInnerBoundry}
              showCharts={showCharts}
              showDrilldown={showDrilldown}
              mapTypes={mapTypes}
              anchorEl={anchorEl}
              handleClick={handleClick}
              tripStatus={tripStatus}
              anchorElTrips={anchorElTrips}
              handlePopoverClose={handlePopoverClose}
              onSelectTripStatus={onSelectTripStatus}
              handleClose={handleClose}
              selectedMapType={selectedMapType}
              tripState={tripState}
              getTripStatus={getTripStatus}
              setSelectedMapType={(val: any) => {
                setSelectedMapType(val);
              }}
              setMapTypes={(val: any) => {
                setMapTypes(val);
              }}
              setShowVehicles={(val: any) => {
                setShowVehicles(val);
              }}
              setTrackedUsers={(val: any) => {
                setTrackedUsers(val);
              }}
              setShowUser={(val: any) => {
                setShowUser(val);
              }}
              setDetails={(val: any) => {
                setDetails(val);
              }}
              setShowCustomerCluster={(val: any) => {
                setShowCustomerCluster(val);
              }}
              setShowInnerBoundry={(val: any) => {
                setShowInnerBoundry(val);
              }}
              setShowOuterBoundry={(val: any) => {
                setShowOuterBoundry(val);
              }}
              setShowDrilldown={(val: any) => {
                setShowDrilldown(val);
              }}
              setShowCharts={(val: any) => {
                setShowCharts(val);
              }}
              setPlottings={(val: any) => {
                setPlottings(val);
              }}
              setShowDealer={(val: any) => {
                setShowDealer(val);
              }}
              setShowLabels={(val: any) => {
                setShowLabels(val);
              }}
              setShowRoute={(val: any) => {
                setShowRoute(val);
              }}
              setShowTerritory={(val: any) => {
                setShowTerritory(val);
              }}
              setShowTripDelivery={(val: any) => {
                setShowTripDelivery(val);
              }}
              setPolyEdits={(val: any) => {
                setPolyEdits(val);
              }}
              setShowRecords={(val: any) => {
                setShowRecords(val);
              }}
              setShowMarker={(val: any) => {
                setShowMarker(val);
              }}
            />
          </div>

          <RightSideDrawer
            selectedCustomers={selectedCustomers}
            transferring={transferring}
            reloadTerritories={reloadTerritories}
            showTripDelivery={showTripDelivery}
            polyEdits={polyEdits}
            showTerritory={showTerritory}
            dealers={dealers}
            dealersRef={dealersRef}
            showUser={showUser}
            usersData={usersData}
            plottings={plottings}
            plotDetail={plotDetail}
            setShowMarker={setShowMarker}
            details={details}
            customers={customers}
            getUsersOnMap={getUsersOnMap}
            tripDelivery={tripDelivery}
            setTrackedUsers={(val: any) => {
              setTrackedUsers(val);
            }}
            setShowUser={(val: any) => {
              setShowUser(val);
            }}
            setShowCustomerCluster={(val: any) => {
              setShowCustomerCluster(val);
            }}
            setCustomers={(val: any) => {
              setCustomers(val);
            }}
            setPolyEdits={(val: any) => {
              setPolyEdits(val);
            }}
            setTransferring={(val: any) => {
              setTransferring(val);
            }}
            setTripDelivery={(val: any) => {
              setTripDelivery(val);
            }}
            setShowTripDelivery={(val: any) => {
              setShowTripDelivery(val);
            }}
            setDetails={(val: any) => {
              setDetails(val);
            }}
            setPlottings={(val: any) => {
              setPlottings(val);
            }}
            onLocationUpdate={onTripDeliveries}
          />

          <MapShare mapRef={mapRef} />

          <MapLeftSideFilters
            scavenging={scavenging}
            streetView={streetView}
            setScavenging={(val: any) => {
              setScavenging(val);
            }}
            setStreetView={(val: any) => {
              setStreetView(val);
            }}
          />
        </div>
      )}
    </>
  );
};

export default withSnackbar(AiMap);
